import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Menu from "@material-ui/core/Menu";
import MoreIcon from "@material-ui/icons/MoreVert";
import { Link } from "react-scroll";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
    backgroundColor: "#263238",
  },
  title: {
    display: "none",
    fontFamily: "cursive",
    fontSize: "1.6em",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  logo: {
    height: 60,
    width: 120,
  },
  navText: {
    color: "#707070",
    fontFamily: "Azeret Mono",
    textDecoration: "none",
    fontSize: "1.125em",
    fontWeight: "bold",
    cursor: "pointer",
    marginLeft: 15,
    marginRight: 15,
    "&:hover": {
      color: "#18FFFF",
      transition: "all .6s",
      textShadow: "0px 4px 3px rgba(0,0,0,0.4)",
    },
  },
  mobNavigation: {
    color: "#000",
    textDecoration: "none",
    display: "flex",
    fontFamily: "Azeret Mono",
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

export default function Header() {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const menuId = "primary-search-account-menu";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    ></Menu>
  );

  const mobileMenuId = "primary-search-account-menu-mobile";
  const renderMobileMenu = (
    <Menu
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={mobileMenuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      <MenuItem>
        <Link
          to="home"
          spy={true}
          smooth={true}
          offset={-80}
          className={classes.mobNavigation}
        >
          Home
        </Link>
      </MenuItem>
      <MenuItem>
        <Link
          to="about"
          spy={true}
          smooth={true}
          offset={-80}
          className={classes.mobNavigation}
        >
          About
        </Link>
      </MenuItem>
      <MenuItem>
        <Link
          to="myWork"
          spy={true}
          smooth={true}
          offset={-120}
          className={classes.mobNavigation}
        >
          My Work
        </Link>
      </MenuItem>
      <MenuItem>
        <Link
          to="skills"
          spy={true}
          smooth={true}
          offset={-120}
          className={classes.mobNavigation}
        >
          Specialization
        </Link>
      </MenuItem>
      <MenuItem>
        <Link
          to="contact"
          spy={true}
          smooth={true}
          className={classes.mobNavigation}
        >
          Contact
        </Link>
      </MenuItem>
    </Menu>
  );

  return (
    <div className={classes.grow}>
      <AppBar
        position="fixed"
        style={{ backgroundColor: "#263238" }}
        elevation={0}
      >
        <Toolbar>
          <img src="/asc-logo.svg" alt="logo" className={classes.logo} />
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <Link
              to="home"
              spy={true}
              smooth={true}
              offset={-80}
              className={classes.navText}
            >
              Home
            </Link>
            <Link
              to="about"
              spy={true}
              smooth={true}
              offset={-80}
              className={classes.navText}
            >
              About
            </Link>

            <Link
              to="myWork"
              spy={true}
              smooth={true}
              offset={-120}
              className={classes.navText}
            >
              My Work
            </Link>
            <Link
              to="skills"
              spy={true}
              smooth={true}
              offset={-120}
              className={classes.navText}
            >
              Specialization
            </Link>
            <Link
              to="contact"
              spy={true}
              smooth={true}
              className={classes.navText}
            >
              Contact
            </Link>
          </div>
          <div className={classes.sectionMobile}>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
    </div>
  );
}
